import { VeltComments, VeltSidebarButton, VeltCommentsSidebar, useCommentUtils } from '@veltdev/react';
import './CommentsPageModePage.css';

function CommentsPageModePage() {
    let commentElement = useCommentUtils()
    commentElement?.disableTextComments()
    
    return (
        <>
            <VeltComments />
            <VeltCommentsSidebar pageMode={true}/>
            <div className="comment-tool-container">
                <p className='boujeeText'>Click the Comments Sidebar button in the bottom right.</p>
                <VeltSidebarButton />
            </div>
        </>
    )
}

export default CommentsPageModePage;